module.exports = "/_next/static/images/IvanGalkin-495f1844e84d79b2a7b029e73e4144f5.webp";